import React,{useState} from 'react'
import classes from './Card.module.css'

const Card = ({faq}) => {
  const [show,setShow] = useState(false);

  // console.log(show)
  return (
    <>
      <div className={classes.card}>
      <div className={classes.card_title} onClick={()=>setShow(!show)}>
      <i className={`pi ${!show ? 'pi-plus-circle' : 'pi-minus-circle'} ${classes.icon}`}></i>
      <p className={classes.ques}>{faq?.question}</p>
      </div>
      {
        show && 
        <div className={`${classes.card_desc} `}>
         {faq?.answer}
      </div>
      }
      </div>
    </>
  )
}

export default Card
